// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*{
  margin:0;
  padding:0;
  box-sizing:border-box;
}

.login-page{
  min-height:100vh;
  display:flex;
  justify-content:center;
  align-items:center;
  padding:20px;
  background:linear-gradient(135deg,#0f172a,#1e293b,#0f172a);
}

.login-card{
  width:100%;
  max-width:420px;
  background:#ffffff;
  border-radius:20px;
  padding:35px;
  box-shadow:0 20px 50px rgba(0,0,0,0.25);
}

.login-header{
  text-align:center;
  margin-bottom:30px;
}

.login-header h1{
  color:#0f172a;
  font-size:32px;
  font-weight:700;
}

.login-header p{
  color:#64748b;
  margin-top:8px;
}

.form-group{
  margin-bottom:20px;
}

.form-group label{
  display:block;
  margin-bottom:8px;
  font-weight:600;
  color:#334155;
}

.form-group input{
  width:100%;
  padding:14px;
  border:1px solid #cbd5e1;
  border-radius:10px;
  font-size:15px;
}

.form-group input:focus{
  outline:none;
  border-color:#2563eb;
}

.login-btn{
  width:100%;
  border:none;
  padding:14px;
  border-radius:10px;
  background:#2563eb;
  color:#fff;
  font-size:16px;
  font-weight:600;
  cursor:pointer;
}

.login-btn:hover{
  background:#1d4ed8;
}

.login-footer{
  margin-top:20px;
  text-align:center;
  color:#94a3b8;
  font-size:13px;
}

@media(max-width:768px){

  .login-card{
    padding:25px;
  }

  .login-header h1{
    font-size:26px;
  }

  .form-group input{
    padding:12px;
  }

  .login-btn{
    padding:12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/Login.css"],"names":[],"mappings":"AAAA;EACE,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["*{\n  margin:0;\n  padding:0;\n  box-sizing:border-box;\n}\n\n.login-page{\n  min-height:100vh;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  padding:20px;\n  background:linear-gradient(135deg,#0f172a,#1e293b,#0f172a);\n}\n\n.login-card{\n  width:100%;\n  max-width:420px;\n  background:#ffffff;\n  border-radius:20px;\n  padding:35px;\n  box-shadow:0 20px 50px rgba(0,0,0,0.25);\n}\n\n.login-header{\n  text-align:center;\n  margin-bottom:30px;\n}\n\n.login-header h1{\n  color:#0f172a;\n  font-size:32px;\n  font-weight:700;\n}\n\n.login-header p{\n  color:#64748b;\n  margin-top:8px;\n}\n\n.form-group{\n  margin-bottom:20px;\n}\n\n.form-group label{\n  display:block;\n  margin-bottom:8px;\n  font-weight:600;\n  color:#334155;\n}\n\n.form-group input{\n  width:100%;\n  padding:14px;\n  border:1px solid #cbd5e1;\n  border-radius:10px;\n  font-size:15px;\n}\n\n.form-group input:focus{\n  outline:none;\n  border-color:#2563eb;\n}\n\n.login-btn{\n  width:100%;\n  border:none;\n  padding:14px;\n  border-radius:10px;\n  background:#2563eb;\n  color:#fff;\n  font-size:16px;\n  font-weight:600;\n  cursor:pointer;\n}\n\n.login-btn:hover{\n  background:#1d4ed8;\n}\n\n.login-footer{\n  margin-top:20px;\n  text-align:center;\n  color:#94a3b8;\n  font-size:13px;\n}\n\n@media(max-width:768px){\n\n  .login-card{\n    padding:25px;\n  }\n\n  .login-header h1{\n    font-size:26px;\n  }\n\n  .form-group input{\n    padding:12px;\n  }\n\n  .login-btn{\n    padding:12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
